import PropTypes from "prop-types";
import * as React from "react";
import { translate, Interpolate } from "react-i18next";
import { x, t } from "helpers/localization";
import isEmpty from "lodash/isEmpty";
import SearchResultTableHead from "./SearchResultTableHead";
import SearchResultTableItem from "./SearchResultTableItem";
import { scrollToY } from "helpers/animate";
import styles from "./SearchResult.scss";
import settings from "settings";
import { BattleSelector } from "../UIKit";

import { ErrorLoad, Message, Paginator, Spinner, StepCSSTransitionGroup, Table, TableBody } from "@wg/wows-react-uikit";

const propTypes = {
  battleTypes: PropTypes.array.isRequired,
  currentAccount: PropTypes.shape({
    clanId: PropTypes.number
  }).isRequired,
  searchResult: PropTypes.shape({
    battleTypeSelected: PropTypes.string.isRequired,
    error: PropTypes.object,
    isFetchedBefore: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    meta: PropTypes.object,
    page: PropTypes.number.isRequired,
    term: PropTypes.string.isRequired
  }).isRequired,

  onBattleTypeChange: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired,
  onPageChanged: PropTypes.func.isRequired,
  onReloadClick: PropTypes.func.isRequired,

  joinClan: PropTypes.func.isRequired,

  t: PropTypes.func.isRequired
};

class SearchResult extends React.PureComponent {


  constructor(props) {
    super(props);

    this.state = {
      fetchByNewPage: false
    };

    this.app = document.getElementById('app');
    this.stickyContainer = null;
  }

  UNSAFE_componentWillReceiveProps(newProps) {// eslint-disable-line
    let isPageChanged = this.props.searchResult.page !== newProps.searchResult.page;
    if (isPageChanged) {
      if (!this.stickyContainer) {
        this.stickyContainer = document.getElementById('search-result-sticky-container');
      }
      scrollToY(this.app, this.stickyContainer.offsetTop - this.app.offsetTop);
    }
    this.setState({ fetchByNewPage: isPageChanged });
  }

  render() {
    const t = this.props.t;

    if (this.props.searchResult.isFetching && this.props.searchResult.items.length === 0) {
      return <div className={styles.spinner}>
                    <Spinner label={t('Ищем кланы')} />
                </div>;
    }

    if (this.props.searchResult.error) {
      return <StepCSSTransitionGroup level={1}>
                    <ErrorLoad key="error-load" message={t('Не удалось получить информацию о кланах.')} onReloadClick={this.props.onReloadClick} t={t} />
                </StepCSSTransitionGroup>;
    }

    const items = this.props.searchResult.items;
    if (isEmpty(items) && !this.props.searchResult.isFetching) {
      return <Message type="empty">{t('Кланы с таким названием или тегом не найдены')}</Message>;
    }

    let paginator = null;
    let displayedTotal = '0';
    if (this.props.searchResult.meta) {
      displayedTotal = this.props.searchResult.meta.total > settings.search.searchResultMaxItems ? `${settings.search.searchResultMaxItems}+` : this.props.searchResult.meta.total;

      paginator = <Paginator key="paginator" page={this.props.searchResult.page} total={this.props.searchResult.meta.total} limit={settings.search.limit} isFetching={this.state.fetchByNewPage} isDisabled={this.props.searchResult.isFetching} onSelectedPage={this.props.onPageChanged} />;
    }

    return <StepCSSTransitionGroup level={1}>
                <BattleSelector key="battle-selector" items={this.props.battleTypes} selected={this.props.searchResult.battleTypeSelected} onBattleTypeChange={this.props.onBattleTypeChange} />
                <div key="total" className={styles.total}>
                    <Interpolate i18nKey={x('Найденные кланы: %(totalCount)s')} totalCount={<span className={styles.totalValue}>{displayedTotal}</span>} />
                </div>
                <Table key="table" isFetching={this.props.searchResult.isFetching} stickyContainerId="search-result-sticky-container">
                    <SearchResultTableHead stickyContainerId="search-result-sticky-container" />
                    <TableBody>
                        {items.map(clan => <SearchResultTableItem key={clan.id} clan={clan} term={this.props.searchResult.term} currentAccount={this.props.currentAccount} onClick={this.props.onItemClick} joinClan={this.props.joinClan} t={t} />)}
                    </TableBody>
                </Table>
                {paginator}
            </StepCSSTransitionGroup>;
  }
}

SearchResult.propTypes = propTypes;

export default translate()(SearchResult);